import styled, {css} from 'styled-components'

import {media} from '../../../theme'

import '@ongov/ontario-design-system-design-tokens/dist/css/_variables.css'

export const SearchContainer = styled.div`
  display: block;

  ${props =>
    props.searchOpen &&
    css`
      display: flex;
    `};

  @media ${media.medium} {
    display: block;
  }
`

export const SearchLabel = styled.label`
  position: absolute !important;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
`

const OntarioInput = styled.input`
  border: 2px solid var(--ontario-colour-accent-icon-colours-black);
  border-radius: var(--ontario-global-tokens-radius);
  box-sizing: border-box;
  color: var(--ontario-colour-accent-icon-colours-black);
  display: block;
  font-size: 1rem;
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  line-height: 1.5;
  margin: 0 0 var(--ontario-spacing-7);
  max-width: 48rem;
  width: 100%;
  padding: 0.625rem var(--ontario-spacing-4);
  transition: box-shadow 0.1s ease-in-out;

  &:focus,
  &:active {
    border: none;
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus);
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
  }
`

export const SearchSubmitButton = styled.button`
  border: 0;
  border-radius: 0 3px 3px 0;
  background-color: #f2f2f2;
  color: var(--ontario-colour-accent-icon-colours-black);
  margin: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: var(--ontario-font-weights-semi-bold);
  font-size: 1.125rem;
  height: 48px;
  line-height: 1.56;

  position: absolute;
  right: var(--ontario-spacing-0);
  top: 4px;
  cursor: pointer;

  padding-left: var(--ontario-spacing-3);
  padding-right: var(--ontario-spacing-3);

  &:hover {
    background-color: var(--ontario-colour-system-link-hover);
    color: var(--ontario-colour-greyscale-white);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 var(--ontario-global-tokens-radius)
      var(--ontario-colour-system-focus);
    background-color: var(--ontario-colour-system-link-hover);
    color: var(--ontario-colour-greyscale-white);
  }

  &:active {
    background-color: var(--ontario-colour-system-link-active);
    color: var(--ontario-colour-greyscale-white);
  }

  &:hover,
  &:active,
  &:focus {
    svg {
      fill: var(--ontario-colour-greyscale-white);
    }
  }

  svg {
    margin-right: var(--ontario-spacing-0);
    width: 2rem;
    height: 2rem;
    margin-bottom: 0;
    fill: var(--ontario-colour-accent-icon-colours-black);
  }

  @media (max-width: 40em) {
    top: 6px;
  }
`

export const SearchInput = styled(OntarioInput)`
  border-width: 0;
  margin-bottom: var(--ontario-spacing-0);
  height: 48px !important;
  padding-left: var(--ontario-spacing-3);
  padding-right: 7.2rem;

  &:invalid + input[type='reset'] {
    display: none;
  }

  &:invalid + div[type='reset'] {
    display: none;
  }

  &:focus {
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus);
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;

    & ~ ${SearchSubmitButton} {
      background-color: var(--ontario-colour-system-link);
      color: var(--ontario-colour-greyscale-white);

      svg {
        fill: var(--ontario-colour-greyscale-white);
      }

      &:hover {
        background-color: var(--ontario-colour-system-link-hover);
        color: var(--ontario-colour-greyscale-white);
      }
    }
  }

  // Remove auto X icon for IE and Edge on input area
  &::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }

  // Remove red outline around input area on Firefox
  &:invalid:focus {
    box-shadow: 0 0 0 4px var(--ontario-colour-system-focus);
    -moz-box-shadow: none;
  }

  &:invalid:not(:focus) {
    box-shadow: none;
    -moz-box-shadow: none;
  }

  @media ${media.small} {
    padding-left: var(--ontario-spacing-4);
    padding-right: 6.4rem;
  }
  @media ${media.medium} {
    padding-left: 0.75rem;
    padding-right: 6.4rem;
  }
`

export default {
  SearchContainer,
  SearchSubmitButton,
  SearchInput,
  SearchLabel,
}
